define(function(require) {
  const rowView = require('./v_itv_action_data_item');
  return Marionette.CollectionView.extend({
    config: {},
    tagName: 'div',
    childView: rowView,
    className: 'action-container',
    initialize: function(options) {
      this.config = options.config;
      this.modalRegion = options.modalRegion;
      //the callbacks are on the data object. when this is converted into a collection,
      //the functions are removed. We need to pass them in separately to the child view.
      //to accomplish this, we'll add an index attribute so we can match things up.
      this.callbacks = [];
      $.each(options.data, (index, el) => {
        el.index = index;
        this.callbacks.push(el.callback);
      });

    },
    childViewOptions: function(model, index) {
      return {
        config: this.config,
        modalRegion: this.modalRegion,
        callback: this.callbacks[index]
      }
    }
  })
});
